<template>
  <div class="flex flex-wrap flex-col sm:flex-row justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
    <div class="text-xl font-bold text-center">
      Informes de Embargos
    </div>
    <div class="flex w-full sm:w-auto flex-wrap gap-3">
      <button @click="downloadReport()" class="px-4 py-2 text-white bg-blue-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-blue-600 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"/>
          </svg>
        <span class="ml-3">Descargar informe</span>
      </button>
    </div>
  </div>

  <div class="flex flex-wrap sm:gap-3 flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:justify-between w-full px-4 mb-2 mt-4 items-center">
    <div class="flex flex-wrap bg-gray-100 w-full lg:w-1/4 items-center rounded-lg">

      <template v-if="queriesToUpdate['criterion'] === 'fecha_oficio' || queriesToUpdate['criterion'] === 'fecha_recibido_oficio' || queriesToUpdate['criterion'] === 'fecha_egreso'">
        <DateRangePickerComponent @dateRangePicker="(newDateRangePicker)=>
          {dateRangePicker = newDateRangePicker}"></DateRangePickerComponent>
      </template>

      <template v-else-if="queriesToUpdate['criterion'] === 'valor_inicial' || queriesToUpdate['criterion'] === 'valor_actual' || queriesToUpdate['criterion'] === 'valor'">
        <div class="flex items-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="inline-block h-4 w-4 mx-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input class="inline-block bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
                type="number" @change="(newSearch) => { valueRangeToUpdate['inicial'] = newSearch.target.value; }" :placeholder="'Desde'"/>
          <input class="inline-block bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
                type="number" @change="(newSearch) => { valueRangeToUpdate['final'] = newSearch.target.value; }" :placeholder="'Hasta'" style="border-left-color: black;"/>
        </div>
      </template>

      <template v-else>
        <svg xmlns="http://www.w3.org/2000/svg" class="inline-block h-4 w-4 mx-2" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
        <input v-model="queriesToUpdate.search" class="inline-block bg-gray-100 outline-none border-transparent focus:border-transparent focus:ring-0 rounded-lg text-sm"
            type="text" @change="(newSearch)=>{queriesToUpdate['search'] = newSearch.target.value;}" :disabled="!queriesToUpdate['criterion']" :placeholder="queriesToUpdate['criterion']?'Buscar...':'Seleccione un filtro...'"/>
      </template>

    </div> 
    <div class="flex-row flex-wrap flex gap-5 w-full sm:w-auto items-end">
      <div class="w-full sm:w-auto m-0">
        <select v-model="Tipo_embargo" id="Tipo_embargo" @change="{changeTable(); executeQueries()}"
                class="w-full mt-3 border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
          <option value="persona">Embargos Personas</option>
          <option value="gobernacion">Embargos Gobernación</option>
          <option value="cuentas">Cuentas Bancarias</option>
          <option value="consolidado">Consolidado Embargos Personas</option>
          <option value="consolidado_gobernacion">Consolidado Embargos Gobernación</option>
        </select>
      </div>

      <!--SI ES EMBARGO persona FILTRAR Y ORDENAR-->
      <template v-if="Tipo_embargo==='persona'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['criterion'] = newFiltro.target.value}"
                  class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0" >
            <option value="" selected>Filtrar por</option>
            <option value="numero_proceso">Número Proceso</option>
            <option value="embargos_personas.tipoProceso.nombre">Tipo Proceso</option>
            <option value="embargos_personas.entidadEmisora.nombre">Entidad Emisora</option>
            <option value="numero_oficio">Número Oficio</option>
            <option value="fecha_oficio">Fecha Oficio</option>
            <option value="fecha_recibido_oficio">Fecha Recibido OFicio</option>
            <option value="embargos_personas.demandante.identificacion">Identificación Demandante</option>
            <option value="embargos_personas.demandante.primer_nombre">Primer Nombre Demandante</option>
            <option value="embargos_personas.demandante.segundo_nombre">Segundo Nombre Demandante</option>
            <option value="embargos_personas.demandante.primer_apellido">Primer Apellido Demandante</option>
            <option value="embargos_personas.demandante.segundo_apellido">Segundo Apellido Demandante</option>
            <option value="embargos_personas.demandado.tipoPersona.nombre">Tipo Persona Demandado</option>
            <option value="embargos_personas.demandado.identificacion">Identificación Demandado</option>
            <option value="embargos_personas.demandado.primer_nombre">Primer Nombre Demandado</option>
            <option value="embargos_personas.demandado.segundo_nombre">Segundo Nombre Demandado</option>
            <option value="embargos_personas.demandado.primer_apellido">Primer Apellido Demandado</option>
            <option value="embargos_personas.demandado.segundo_apellido">Segundo Apellido Demandado</option>
            <option value="valor_inicial">Limite Embargo</option>
            <option value="valor_actual">Saldo Actual</option>
          </select>
        </div>
        <div class="w-full sm:w-auto m-0">
          <select @change="(newOrderBy)=>{queriesToUpdate['orderBy'] = newOrderBy.target.value}" class="w-full sm:w-auto mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="" selected>Ordenar por</option>
            <option value="numero_proceso">Número Proceso</option>
            <option value="embargos_personas.tipoProceso.nombre">Tipo Proceso</option>
            <option value="embargos_personas.entidadEmisora.nombre">Entidad Emisora</option>
            <option value="numero_oficio">Número Oficio</option>
            <option value="fecha_oficio">Fecha Oficio</option>
            <option value="fecha_recibido_oficio">Fecha Recibido OFicio</option>
            <option value="embargos_personas.demandante.identificacion">Identificación Demandante</option>
            <option value="embargos_personas.demandante.primer_nombre">Primer Nombre Demandante</option>
            <option value="embargos_personas.demandante.segundo_nombre">Segundo Nombre Demandante</option>
            <option value="embargos_personas.demandante.primer_apellido">Primer Apellido Demandante</option>
            <option value="embargos_personas.demandante.segundo_apellido">Segundo Apellido Demandante</option>
            <option value="embargos_personas.demandado.tipoPersona.nombre">Tipo Persona Demandado</option>
            <option value="embargos_personas.demandado.identificacion">Identificación Demandado</option>
            <option value="embargos_personas.demandado.primer_nombre">Primer Nombre Demandado</option>
            <option value="embargos_personas.demandado.segundo_nombre">Segundo Nombre Demandado</option>
            <option value="embargos_personas.demandado.primer_apellido">Primer Apellido Demandado</option>
            <option value="embargos_personas.demandado.segundo_apellido">Segundo Apellido Demandado</option>
            <option value="valor_inicial">Limite Embargo</option>
            <option value="valor_actual">Saldo Actual</option>
          </select>
        </div>
      </template>

      <!--SI ES EMBARGO gobernacion FILTRAR Y ORDENAR-->
      <template v-else-if="Tipo_embargo==='gobernacion'">
        <div class="w-full sm:w-auto m-0">
          <select @change="(newFiltro)=>{queriesToUpdate['criterion'] = newFiltro.target.value}" class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="" selected>Filtrar por</option>
            <option value="numero_egreso">Número Egreso</option>
            <option value="fecha_egreso">Fecha Egreso</option>
            <option value="numero_proceso">Número Proceso</option>
            <option value="embargos_personas.demandante.identificacion">Identificación Demandante</option>
            <option value="embargos_personas.demandante.primer_nombre">Primer Nombre Demandante</option>
            <option value="embargos_personas.demandante.segundo_nombre">Segundo Nombre Demandante</option>
            <option value="embargos_personas.demandante.primer_apellido">Primer Apellido Demandante</option>
            <option value="embargos_personas.demandante.segundo_apellido">Segundo Apellido Demandante</option>
            <option value="observaciones">Observaciones</option>
            <option value="tipo_embargo">Tipo Embargo</option>
            <option value="embargos_gobernacion.cuentaBancaria.banco.nombre_banco">Banco</option>
            <option value="embargos_gobernacion.cuentaBancaria.cuenta_bancaria">Cuenta Bancaria</option>
            <option value="embargos_gobernacion.cuentaBancaria.tipo_cuenta">Tipo Cuenta</option>
            <option value="embargos_gobernacion.fuenteConcreta.nombre">Secretaria Ejecutora</option>
            <option value="valor">Limite Embargo</option>
            <option value="valor_actual">Saldo Actual</option>
          </select>
        </div>
        <div class="w-full sm:w-auto m-0">
          <select @change="(newOrderBy)=>{queriesToUpdate['orderBy'] = newOrderBy.target.value}" class="w-full sm:w-auto mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="" selected>Ordenar por</option>
            <option value="numero_egreso">Número Egreso</option>
            <option value="fecha_egreso">Fecha Egreso</option>
            <option value="numero_proceso">Número Proceso</option>
            <option value="embargos_personas.demandante.identificacion">Identificación Demandante</option>
            <option value="embargos_personas.demandante.primer_nombre">Primer Nombre Demandante</option>
            <option value="embargos_personas.demandante.segundo_nombre">Segundo Nombre Demandante</option>
            <option value="embargos_personas.demandante.primer_apellido">Primer Apellido Demandante</option>
            <option value="embargos_personas.demandante.segundo_apellido">Segundo Apellido Demandante</option>
            <option value="observaciones">Observaciones</option>
            <option value="tipo_embargo">Tipo Embargo</option>
            <option value="embargos_gobernacion.cuentaBancaria.banco.nombre_banco">Banco</option>
            <option value="embargos_gobernacion.cuentaBancaria.cuenta_bancaria">Cuenta Bancaria</option>
            <option value="embargos_gobernacion.cuentaBancaria.tipo_cuenta">Tipo Cuenta</option>
            <option value="valor">Limite Embargo</option>
            <option value="valor_actual">Saldo Actual</option>
          </select>
        </div>
      </template>

      <!--SI ES FILTRADO POR CUENTAS FILTRAR Y ORDENAR-->
      <template v-else-if="Tipo_embargo==='cuentas'">
              <div class="w-full sm:w-auto m-0">
                <select @change="(newFiltro)=>{queriesToUpdate['criterion'] = newFiltro.target.value}" class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
                  <option value="" selected>Filtrar por</option>
                  <option value="banco.nombre_banco">Nombre Banco</option>
                  <option value="nombre_cuenta">Nombre Cuenta</option>
                  <option value="cuenta_bancaria">Número Cuenta</option>
                  <option value="tipo_cuenta">Tipo Cuenta</option>
                </select>
              </div>
              <div class="w-full sm:w-auto m-0">
                <select @change="(newOrderBy)=>{queriesToUpdate['orderBy'] = newOrderBy.target.value}" class="w-full sm:w-auto mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
                  <option value="" selected>Ordenar por</option>
                  <option value="banco.nombre_banco">Nombre Banco</option>
                  <option value="nombre_cuenta">Nombre Cuenta</option>
                  <option value="cuenta_bancaria">Número Cuenta</option>  
                  <option value="tipo_cuenta">Tipo Cuenta</option>
                </select>
              </div>
      </template>

      <!--SI ES CONSOLIDADO FILTRAR POR VIGENCIA-->
      <template v-else-if="Tipo_embargo==='consolidado'">
        <div class="w-full sm:w-auto m-0">
          <label class="block text-xs text-gray-600">Vigencia (año fecha oficio)</label>
          <input type="number" v-model="vigenciaConsolidado" placeholder="Ej: 2026"
                 class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
        </div>
      </template>

      <!--SI ES CONSOLIDADO GOBERNACION FILTRAR POR BANCO / CUENTA / VIGENCIA-->
      <template v-else-if="Tipo_embargo==='consolidado_gobernacion'">
        <div class="w-full sm:w-auto m-0">
          <label class="block text-xs text-gray-600">Banco</label>
          <select v-model="filtrosConsolidadoGobernacion.id_banco"
                  class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="">Todos</option>
            <option v-for="(banco, index) of collectionBancosInforme" :key="'BC'+index" :value="banco.id">{{ banco.nombre_banco }}</option>
          </select>
        </div>
        <div class="w-full sm:w-auto m-0">
          <label class="block text-xs text-gray-600">Cuenta bancaria</label>
          <select v-model="filtrosConsolidadoGobernacion.id_cuenta_bancaria"
                  class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 pl-2 pr-8 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
            <option value="">Todas</option>
            <option v-for="(cuenta, index) of cuentasFiltradasInforme" :key="'CC'+index" :value="cuenta.id">{{ cuenta.cuenta_bancaria }} - {{ cuenta.nombre_cuenta }}</option>
          </select>
        </div>
        <div class="w-full sm:w-auto m-0">
          <label class="block text-xs text-gray-600">Vigencia</label>
          <input type="number" v-model="filtrosConsolidadoGobernacion.vigencia" placeholder="Ej: 2026"
                 class="w-full sm:w-auto border border-gray-300 rounded-md text-gray-600 px-2 bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0">
        </div>
      </template>

      <!-- ORDEN ASC/DESC-->
      <button @click="orderAscDesc()"
        class="mt-3 sm:m-auto border border-gray-300 rounded-md text-gray-600 px-3 py-[9px] bg-white hover:border-gray-400 focus:outline-none text-xs focus:ring-0" style=" margin-top: 30px;">
        <span>Ordenar {{ queriesToUpdate['order']?queriesToUpdate['order']:'ASC' }}.</span>
      </button>

      <button @click="executeQueries()"
              class="mt-3 font-bold sm:m-auto border border-gray-300 hover:border-gray-400 px-3 py-[9px] text-white bg-green-500 hover:bg-green-600 rounded-md focus:outline-none text-xs focus:ring-0 flex flex-row items-center space-x-2" style=" margin-top: 30px;">
        <span>BUSCAR</span>
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- CONTENIDO TABLAS -->
  <div class="mt-6 overflow-x-auto">
    <!-- EMBARGO persona LISTA VISTA -->
    <template v-if="Tipo_embargo==='persona'">
      <table class="w-full table-auto">
        <thead class="">
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            <th class="px-4 py-3">Número Proceso</th>
            <th class="px-4 py-3">Tipo Proceso</th>
            <th class="px-4 py-3">Entidad Notificadora</th>
            <th class="px-4 py-3">Número Oficio</th>
            <th class="px-4 py-3">Fecha Oficio</th>
            <th class="px-4 py-3">Fecha Recibido OFicio</th>
            <th class="px-4 py-3">Identificación Demandante</th>
            <th class="px-4 py-3">Nombre Demandante</th>
            <th class="px-4 py-3">Tipo Persona Demandado</th>
            <th class="px-4 py-3">Identificación Demandado</th>
            <th class="px-4 py-3">Nombre Demandado</th>
            <th class="px-4 py-3">Limite Embargo</th>
            <th class="px-4 py-3">Saldo Actual</th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
          <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
            <td class="px-4 py-4">
              {{ data.numero_proceso }}
            </td>
            <td class="px-4 py-4">
              {{ data.tipoProceso.nombre }}
            </td>
            <td class="px-4 py-4">
              {{ data.entidadEmisora ? data.entidadEmisora.nombre : data.entidad_notifica_embargo }}
            </td>
            <td class="px-4 py-4">
              {{ data.numero_oficio }}
            </td>
            <td class="px-4 py-4">
              {{ data.fecha_oficio }}
            </td>
            <td class="px-4 py-4">
              {{ data.fecha_recibido_oficio }}
            </td>
            <td class="px-4 py-4">
              {{ data.demandante.identificacion }}
            </td>
            <td class="px-4 py-4">
              {{ (data.demandante.primer_nombre || '') + ' ' + (data.demandante.segundo_nombre || '') + ' ' + (data.demandante.primer_apellido || '') + ' ' + (data.demandante.segundo_apellido || '') }}
            </td>
            <td class="px-4 py-4">
              {{ data.demandado.tipoPersona.nombre}}
            </td>
            <td class="px-4 py-4">
              {{ data.demandado.identificacion }}
            </td>
            <td class="px-4 py-4">
              {{ (data.demandado.primer_nombre || '') + ' ' + (data.demandado.segundo_nombre || '') + ' ' + (data.demandado.primer_apellido || '') + ' ' + (data.demandado.segundo_apellido || '') }}
            </td>
            <td class="px-4 py-4">
              {{  vueNumberFormat(data.valor_inicial, {}) }}
            </td>
            <td class="px-4 py-4">
              {{ vueNumberFormat(data.valor_actual, {}) }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!-- EMBARGO gobernacion LISTA VISTA -->
    <template v-else-if="Tipo_embargo==='gobernacion'">
      <table class="w-full table-auto">
        <thead class="">
        <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
          <th class="px-4 py-3">Juzgado / Entidad Cobro</th>
          <th class="px-4 py-3">Tipo Embargo</th>
          <th class="px-4 py-3">Número Oficio</th>
          <th class="px-4 py-3">Número Proceso</th>
          <th class="px-4 py-3">Número Embargo</th>
          <th class="px-4 py-3">Radicado</th>
          <th class="px-4 py-3">Número Egreso</th>
          <th class="px-4 py-3">Fecha Egreso</th>
          <th class="px-4 py-3">Identificación Demandante</th>
          <th class="px-4 py-3">Demandante</th>
          <th class="px-4 py-3">Banco</th>
          <th class="px-4 py-3">Cuenta Bancaria</th>
          <th class="px-4 py-3">Tipo Cuenta</th>
          <th class="px-4 py-3">Fuente</th>
          <th class="px-4 py-3">Fuente Macro</th>
          <th class="px-4 py-3">Limite Embargo</th>
          <th class="px-4 py-3">Saldo</th>
        </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
          <td class="px-4 py-4">
            {{ data.juzgado?.nombre_juzgado || data.entidadCobro?.nombre_entidad}}
          </td>
          <td class="px-4 py-4">
            {{ data.tipo_embargo }}
          </td>
          <td class="px-4 py-4">
            {{ data.numero_oficio }}
          </td>
          <td class="px-4 py-4">
            {{ data.numero_proceso }}
          </td>
          <td class="px-4 py-4">
            {{ data.numero_embargo }}
          </td>
          <td class="px-4 py-4">
            {{ data.radicado }}
          </td>
          <td class="px-4 py-4">
            {{ data.numero_egreso }}
          </td>
          <td class="px-4 py-4">
            {{ data.fecha_egreso }}
          </td>
          <td class="px-4 py-4">
            {{ data.demandante?.identificacion }}
          </td>
          <td class="px-4 py-4">
            {{ (data.demandante.primer_nombre || '') + ' ' + (data.demandante.segundo_nombre || '') + ' ' + (data.demandante.primer_apellido || '') + ' ' + (data.demandante.segundo_apellido || '') }}
          </td>
          <td class="px-4 py-4">
            {{ data.cuentaBancaria?.banco.nombre_banco }}
          </td>
          <td class="px-4 py-4">
            {{ data.cuentaBancaria?.cuenta_bancaria }}
          </td>
          <td class="px-4 py-4">
            {{ data.cuentaBancaria?.tipo_cuenta }}
          </td>
          <td class="px-4 py-4">
            {{ data.cuentaBancaria?.nombre_cuenta }}
          </td>
          <td class="px-4 py-4">
            {{ data.cuentaBancaria?.cuentasFuentesMacro.macroFuente.nombre }}
          </td>
          <td class="px-4 py-4">
            {{  vueNumberFormat(data.valor, {}) }}
          </td>
          <td class="px-4 py-4">
            {{ vueNumberFormat(data.valor_actual, {}) }}
          </td>
        </tr>
        </tbody>
      </table>
    </template>

    <!-- Cuentas Bancarias LISTA VISTA -->
    <template v-else-if="Tipo_embargo==='cuentas'">
      <table class="w-full table-auto">
        <thead class="">
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            <th class="px-4 py-3">Banco</th>
            <th class="px-4 py-3">Nombre Cuenta</th>
            <th class="px-4 py-3">Número Cuenta</th>
            <th class="px-4 py-3">Tipo de Cuenta</th>
            <th class="px-4 py-3">Detalles Embargos Gobernación</th>
            <th class="px-4 py-3">Detalles Embargos Personas</th>
            <th class="px-4 py-3">Total Pagado</th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center border-2">
          <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
            <td class="px-4 py-4 font-bold">
              {{ data.banco.nombre_banco }}
            </td> 
            <td class="px-4 py-4 font-bold">
              {{ data.nombre_cuenta }}
            </td>
            <td class="px-4 py-4 font-bold">
              {{ data.cuenta_bancaria }}
            </td>
            <td class="px-4 py-4 font-bold">
              {{ data.tipo_cuenta }}
            </td>
            <td v-if="data.embargos.length > 0" class="px-4 py-4">
              <div v-for="(embargosGob, index) in data.embargos" :key="index">
                <table class="w-full table-auto">
                  <thead>
                    <tr class="text-sm font-semibold text-center border-2 border-black uppercase bg-gray-300">
                      <th class="px-4 py-3">Número Proceso</th>
                      <th class="px-4 py-3">Número Egreso</th>
                      <th class="px-4 py-3">Número Embargo</th>
                      <th class="px-4 py-3">Dinero Pagado</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm font-normal text-gray-700 text-center border-2">
                    <tr class="text-sm font-semibold text-center border-2 border-black uppercase">
                      <td class="px-4 py-4" >
                        {{ embargosGob.numero_proceso }}
                      </td>
                      <td class="px-4 py-4" >
                        {{ embargosGob.numero_egreso }}
                      </td>
                      <td class="px-4 py-4" >
                        {{ embargosGob.numero_embargo }}
                      </td>
                      <td class="px-4 py-4">
                        {{ `$ ${(parseInt(embargosGob.valor) - parseInt(embargosGob.valor_actual)).toLocaleString()}` }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td class="px-4 py-4" v-else>
              {{ 'No Posee' }}
            </td>
            <td v-if="data.exitososEmbargosPersonas.length > 0" class="px-4 py-4">
              <div v-for="(embargosPersonas, index) in data.exitososEmbargosPersonas" :key="index">
                <table class="w-full table-auto">
                  <thead>
                    <tr class="text-sm font-semibold text-center border-2 border-black uppercase bg-gray-300">
                      <th class="px-4 py-3">Número Proceso</th>
                      <th class="px-4 py-3">Número Egreso</th>
                      <th class="px-4 py-3">Número Oficio</th>
                      <th class="px-4 py-3">Dinero Pagado</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm font-normal text-gray-700 text-center border-2">
                    <tr class="text-sm font-semibold text-center border-2 border-black uppercase">
                      <td class="px-4 py-4" >
                        {{ embargosPersonas.embargos.numero_proceso }}
                      </td>
                      <td class="px-4 py-4" >
                        {{ embargosPersonas.numero_egreso }}
                      </td>
                      <td class="px-4 py-4" >
                        {{ embargosPersonas.embargos.numero_oficio }}
                      </td>
                      <td class="px-4 py-4">
                        {{ `$ ${parseInt(embargosPersonas.valor).toLocaleString()}` }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
            <td v-else class="px-4 py-4" >
              {{ 'No Posee' }}
            </td>
            <td class="px-4 py-4 font-bold">
                {{ `$${(parseInt(data.totalEmbPersonas) + parseInt(data.totalEmbGobernacion)).toLocaleString()}` ?? 'N/A' }}
            </td>

          </tr>
        </tbody>
      </table>
    </template>

    <!-- CONSOLIDADO EMBARGOS PERSONAS VISTA -->
    <template v-else-if="Tipo_embargo==='consolidado'">
      <table class="w-full table-auto">
        <thead class="">
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            <th class="px-4 py-3">Número Proceso</th>
            <th class="px-4 py-3">Fecha Oficio</th>
            <th class="px-4 py-3">Demandado</th>
            <th class="px-4 py-3">Demandante</th>
            <th class="px-4 py-3">Tipo Proceso</th>
            <th class="px-4 py-3">Estado Registro</th>
            <th class="px-4 py-3">Valor Inicial</th>
            <th class="px-4 py-3">Saldo Actual</th>
            <th class="px-4 py-3">Total Liquidaciones</th>
            <th class="px-4 py-3">Total Egresos</th>
            <th class="px-4 py-3">Total Aplicado</th>
            <th class="px-4 py-3">Total Reintegros</th>
            <th class="px-4 py-3">Total Levantamientos</th>
            <th class="px-4 py-3">Pendiente por Legalizar</th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
          <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
            <td class="px-4 py-4">{{ data.numero_proceso }}</td>
            <td class="px-4 py-4">{{ data.fecha_oficio }}</td>
            <td class="px-4 py-4">{{ data.demandado }} ({{ data.identificacion_demandado }})</td>
            <td class="px-4 py-4">{{ data.demandante }} ({{ data.identificacion_demandante }})</td>
            <td class="px-4 py-4">{{ data.tipo_proceso }}</td>
            <td class="px-4 py-4" :class="data.estado_registro === 'borrador' ? 'text-yellow-500 font-extrabold' : 'text-green-500 font-extrabold'">
              {{ data.estado_registro === 'borrador' ? 'Incompleto' : 'Finalizado' }}
            </td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.valor_inicial || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.valor_actual || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_liquidaciones || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_egresos || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_aplicado || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_reintegros || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_levantamientos || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4 font-bold" :class="parseFloat(data.pendiente_por_legalizar) > 0 ? 'text-red-500' : 'text-sky-500'">
              {{ `$ ${parseFloat(data.pendiente_por_legalizar || 0).toLocaleString()}` }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <!-- CONSOLIDADO EMBARGOS GOBERNACION VISTA -->
    <template v-else-if="Tipo_embargo==='consolidado_gobernacion'">
      <div class="flex flex-wrap gap-4 px-4 py-3 bg-gray-50 border rounded-md mx-4 mb-3 text-sm font-bold">
        <div>Total embargado: <span class="text-red-500">$ {{ parseFloat(totalesConsolidadoGobernacion.total_embargado || 0).toLocaleString() }}</span></div>
        <div>Total aplicado: <span class="text-blue-500">$ {{ parseFloat(totalesConsolidadoGobernacion.total_aplicado || 0).toLocaleString() }}</span></div>
        <div>Total levantado: <span class="text-green-600">$ {{ parseFloat(totalesConsolidadoGobernacion.total_levantado || 0).toLocaleString() }}</span></div>
        <div>Saldo actual: <span class="text-sky-500">$ {{ parseFloat(totalesConsolidadoGobernacion.total_saldo_actual || 0).toLocaleString() }}</span></div>
      </div>
      <table class="w-full table-auto">
        <thead class="">
          <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
            <th class="px-4 py-3">Banco</th>
            <th class="px-4 py-3">Cuenta Bancaria</th>
            <th class="px-4 py-3">Vigencia</th>
            <th class="px-4 py-3">Número Proceso</th>
            <th class="px-4 py-3">Radicado Tesorería</th>
            <th class="px-4 py-3">Tipo Embargo</th>
            <th class="px-4 py-3">Demandante</th>
            <th class="px-4 py-3">Fecha Oficio</th>
            <th class="px-4 py-3">Valor Embargado</th>
            <th class="px-4 py-3">Valor Aplicado</th>
            <th class="px-4 py-3">Total Levantamientos</th>
            <th class="px-4 py-3">Saldo Actual</th>
          </tr>
        </thead>
        <tbody class="text-sm font-normal text-gray-700 text-center">
          <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(data, index) in collectionData" :key="index">
            <td class="px-4 py-4">{{ data.banco }}</td>
            <td class="px-4 py-4">{{ data.cuenta_bancaria }} <span v-if="data.nombre_cuenta">({{ data.nombre_cuenta }})</span></td>
            <td class="px-4 py-4">{{ data.vigencia }}</td>
            <td class="px-4 py-4">{{ data.numero_proceso }}</td>
            <td class="px-4 py-4">{{ data.radicado_tesoreria_numero }} <span v-if="data.radicado_tesoreria_fecha">- {{ data.radicado_tesoreria_fecha }}</span></td>
            <td class="px-4 py-4">{{ data.tipo_embargo }}</td>
            <td class="px-4 py-4">{{ data.demandante }}</td>
            <td class="px-4 py-4">{{ data.fecha_oficio }}</td>
            <td class="px-4 py-4 font-bold text-red-500">{{ `$ ${parseFloat(data.valor || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.valor_aplicado || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4">{{ `$ ${parseFloat(data.total_levantamientos || 0).toLocaleString()}` }}</td>
            <td class="px-4 py-4 font-bold" :class="parseFloat(data.valor_actual) > 0 ? 'text-red-500' : 'text-sky-500'">
              {{ `$ ${parseFloat(data.valor_actual || 0).toLocaleString()}` }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </div>

  <!--PAGINACIÓN-->
  <PaginateRefactComponent v-if="showPaginate" :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
    @updateValues="setupUpdateValues">
  </PaginateRefactComponent>
</template>
<script>
import Swal from "sweetalert2";
import DateRangePickerComponent from "@/layouts/DateRangePicker";
import {utils, writeFile} from "xlsx-js-style";
import {useAuth} from "@/components/auth/store/composables";
import {copiaProfunda, separateNumberByComma, useAPIRest} from "@/common/constants";
import {useLayoutMain, listCollectionData} from "@/layouts/main";
import {ref, reactive, computed} from 'vue';
import moment from 'moment';
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";

export default {
  name: 'EmbargosPasivosInformes',
  components: {DateRangePickerComponent,PaginateRefactComponent},
  data: function () {
    return {
      Object: Object,
      console: console,
      dataFile : []
    }
  },
  async setup() {
    const dateRangePicker = ref(undefined);
    const authStored = useAuth();
    const dataUser = ref(localStorage.getItem('user'));
    const idUser = JSON.parse(dataUser.value);
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const queriesToUpdate = ref({});
    const valueRangeToUpdate = ref({});
    const collectionInforme = ref([]);
    const Tipo_embargo = ref('persona');
    const listCollectionDataRef = ref(listCollectionData);
    const showPaginate = ref(true);
    const vigenciaConsolidado = ref('');
    const consolidadoData = ref([]);
    const filtrosConsolidadoGobernacion = ref({ id_banco: '', id_cuenta_bancaria: '', vigencia: '' });
    const totalesConsolidadoGobernacion = ref({});
    const collectionBancosInforme = ref([]);
    const collectionCuentasInforme = ref([]);

    const cuentasFiltradasInforme = computed(() => {
      const idBanco = filtrosConsolidadoGobernacion.value.id_banco;
      if (!idBanco) return collectionCuentasInforme.value;
      return collectionCuentasInforme.value.filter((cuenta) => cuenta.banco && cuenta.banco.id == idBanco);
    });

    const listApi = reactive({
      list: (Tipo_embargo.value == 'persona' ) ? 
      process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL :
      (Tipo_embargo.value == 'persona' ) ? 
      process.env.VUE_APP_NEST_CUENTASEMBARGOS_FINDALL:
      process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL
    });
    
    const filtrarConsolidado = () => {
      const vigencia = String(vigenciaConsolidado.value || '').trim();
      collectionData.value = vigencia
        ? consolidadoData.value.filter((registro) => registro.fecha_oficio && String(registro.fecha_oficio).startsWith(vigencia))
        : consolidadoData.value;
    };

    const listConsolidado = async () => {
      const res = await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_INFORME_CONSOLIDADO, 'GET', authToken.value, undefined, undefined, 'application/json');
      consolidadoData.value = Array.isArray(res) ? res : [];
      filtrarConsolidado();
      showPaginate.value = false;
    };

    const listConsolidadoGobernacion = async () => {
      const filtros = filtrosConsolidadoGobernacion.value;
      const queryParams = {};
      if (filtros.id_banco) queryParams['id_banco'] = filtros.id_banco;
      if (filtros.id_cuenta_bancaria) queryParams['id_cuenta_bancaria'] = filtros.id_cuenta_bancaria;
      if (filtros.vigencia) queryParams['vigencia'] = filtros.vigencia;

      const res = await useAPIRest(process.env.VUE_APP_NEST_EMBARGOGOBERNACION_INFORME_CONSOLIDADO, 'GET', authToken.value, undefined, queryParams, 'application/json');
      collectionData.value = res && Array.isArray(res.registros) ? res.registros : [];
      totalesConsolidadoGobernacion.value = res && res.totales ? res.totales : {};
      showPaginate.value = false;

      if (!collectionBancosInforme.value.length) {
        await listCollectionData(process.env.VUE_APP_NEST_BANCO_FINDALL, {'collectionBancosInforme': collectionBancosInforme}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
      }
      if (!collectionCuentasInforme.value.length) {
        await listCollectionData(process.env.VUE_APP_NEST_CUENTABANCARIA_FINDALL, {'collectionCuentasInforme': collectionCuentasInforme}, authToken.value, undefined, undefined, undefined, undefined, undefined, undefined, false);
      }
    };

    const changeTable = async () => {
      try {
        let res = null;
        queriesToUpdate.value.criterion = '';
        queriesToUpdate.value.search = '';

        if (Tipo_embargo.value === 'consolidado') {
          await listConsolidado();
          return;
        }

        if (Tipo_embargo.value === 'consolidado_gobernacion') {
          await listConsolidadoGobernacion();
          return;
        }

        const apiUrl = Tipo_embargo.value === 'persona' ?
          process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL :
          Tipo_embargo.value === 'cuentas' ? 
          process.env.VUE_APP_NEST_CUENTASEMBARGOS_FINDALL : 
          process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL;
       
          res = await listCollectionData(
            apiUrl,
            {'collectionData': collectionData.value},
            authToken.value,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            true,
            { 'take' : 6}
          );
        
          if (Tipo_embargo.value.toLocaleLowerCase().includes('cuentas') && res && res.length == 0) {
            showPaginate.value = false;
            Swal.fire({
              icon: 'warning',
              title: '¡Atención!',
              text: 'No existen cuentas con pagos realizados a embargos, porfavor verifique.',
            });
          }else if (res && res.length <= 6) {
            showPaginate.value = false;
          }else{
            showPaginate.value = true;
          }
          // Actualizar la referencia reactiva collectionData
          Tipo_embargo.value.toLocaleLowerCase().includes('cuentas') ? collectionData.value = res : collectionData.value = res.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const urlApi = computed(() => {
      if(Tipo_embargo.value == 'persona'){
        return process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL
      }else if (Tipo_embargo.value == 'cuentas') {
        return process.env.VUE_APP_NEST_CUENTASEMBARGOS_FINDALL
      }else{
        return process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL
      }
    });
    
    const {                       
      paginate,       
      queries,        
      setupUpdateValues
    } = await useLayoutMain(view, collectionData, authToken, undefined, undefined, listApi, { 'take' : 6});
    
    return  {
              paginate, 
              queries, 
              collectionInforme, 
              setupUpdateValues, 
              authToken, 
              collectionData, 
              dateRangePicker, 
              listApi, 
              queriesToUpdate, 
              dataUser, 
              idUser,
              valueRangeToUpdate, 
              Tipo_embargo,
              changeTable,
              listCollectionData: listCollectionDataRef,
              urlApi,
              showPaginate,
              vigenciaConsolidado,
              consolidadoData,
              filtrarConsolidado,
              listConsolidado,
              filtrosConsolidadoGobernacion,
              totalesConsolidadoGobernacion,
              collectionBancosInforme,
              collectionCuentasInforme,
              cuentasFiltradasInforme,
              listConsolidadoGobernacion,
            }
  },
  methods: {
    dateTime(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm');
    },
    executeQueries() {
      if (this.Tipo_embargo === 'consolidado') {
        this.filtrarConsolidado();
        return;
      }

      if (this.Tipo_embargo === 'consolidado_gobernacion') {
        this.listConsolidadoGobernacion();
        return;
      }

      if(this.dateRangePicker && 'fecha_oficio' === this.queriesToUpdate.criterion) this.useDateRangePicker();
      else if(this.dateRangePicker && 'fecha_recibido_oficio' === this.queriesToUpdate.criterion) this.useDateRangePicker();
      else if(this.dateRangePicker && 'fecha_egreso' === this.queriesToUpdate.criterion) this.useDateRangePicker();
      else if('valor_actual' === this.queriesToUpdate.criterion) this.rangeValor('valor_actual');
      else if('valor_inicial' === this.queriesToUpdate.criterion) this.rangeValor('valor_inicial');
      else if('valor' === this.queriesToUpdate.criterion) this.rangeValor('valor');

      else this.updateQueries('where', '');
      this.updateQueries('page', '');

      if(this.Tipo_embargo == 'gobernacion'){
        this.listApi.list = process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL;
      }else if (this.Tipo_embargo == 'cuentas') {
        this.listApi.list = process.env.VUE_APP_NEST_CUENTASEMBARGOS_FINDALL;
      }else{
        this.listApi.list = process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL;
      }

      this.queries = copiaProfunda(this.queriesToUpdate);

      if(this.queriesToUpdate.criterion != 'valor_inicial' && this.queriesToUpdate.criterion != 'valor_actual' && this.queriesToUpdate.criterion != 'valor'){
        this.valueRangeToUpdate.inicial = '';
        this.valueRangeToUpdate.final = '';
      }
    },

    orderAscDesc() {
      this.queriesToUpdate['order'] = this.queriesToUpdate['order'] === 'DESC' ? 'ASC' : 'DESC';
    },

    descargar_informe: function () {
      Swal.fire('¡Informe descargado con exito!', '', 'success');
    },

    updateQueries(key, value) {
      this.queriesToUpdate[key] = value;
    },

    useDateRangePicker() {
      let [dateStart, dateEnd] = this.dateRangePicker.getDates();
      dateStart = dateStart.toISOString().split('T')[0];
      dateEnd = dateEnd.toISOString().split('T')[0];
      this.queriesToUpdate['search'] = '';
      if(this.queriesToUpdate.criterion == 'fecha_oficio'){
        this.updateQueries('where', `table.fecha_oficio>='${dateStart}' and table.fecha_oficio<='${dateEnd}'`);
      }else if(this.queriesToUpdate.criterion == 'fecha_recibido_oficio' ){
        this.updateQueries('where', `fecha_recibido_oficio>='${dateStart}' and fecha_recibido_oficio<='${dateEnd}'`);
      }else if(this.queriesToUpdate.criterion == 'fecha_egreso' ){
        this.updateQueries('where', `fecha_egreso>='${dateStart}' and fecha_egreso<='${dateEnd}'`);
      }
    },

    rangeValor(tipo) { 
      this.queriesToUpdate['search'] = '';

      if((this.valueRangeToUpdate.inicial == ''  || this.valueRangeToUpdate.inicial == undefined ) && this.valueRangeToUpdate.final != ''){
        this.updateQueries('where', `table.${tipo} <= '${this.valueRangeToUpdate.final}'`);
      }

      if(this.valueRangeToUpdate.final == ''  || this.valueRangeToUpdate.final == undefined && this.valueRangeToUpdate.inicial != ''){
        this.updateQueries('where', `table.${tipo} >= '${this.valueRangeToUpdate.inicial}'`);
      }

      if(this.valueRangeToUpdate.inicial != ''  && this.valueRangeToUpdate.inicial != undefined && this.valueRangeToUpdate.final != '' && this.valueRangeToUpdate.final != undefined){
        this.updateQueries('where', `table.${tipo}>='${this.valueRangeToUpdate.inicial}' and table.${tipo}<='${this.valueRangeToUpdate.final}'`);
      }
    },

    async downloadReport() {
      if (this.Tipo_embargo === 'consolidado_gobernacion') {
        const wb = utils.book_new();
        const headers = ['BANCO', 'CUENTA BANCARIA', 'NOMBRE CUENTA', 'VIGENCIA', 'NÚMERO PROCESO', 'RADICADO TESORERÍA', 'FECHA RADICADO', 'TIPO EMBARGO', 'DEMANDANTE', 'FECHA OFICIO', 'VALOR EMBARGADO', 'VALOR APLICADO', 'TOTAL LEVANTAMIENTOS', 'SALDO ACTUAL'];
        const excel = [headers.map((titulo) => ({ v: titulo, t: 's', s: { alignment: { horizontal: 'center', vertical: 'middle' }, font: { bold: true, size: 11, color: { rgb: '000000' } }, border: { top: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, left: { style: 'thin', color: { rgb: '000000' } } } } }))];

        for (const registro of this.collectionData) {
          excel.push([
            registro.banco,
            registro.cuenta_bancaria,
            registro.nombre_cuenta,
            registro.vigencia,
            registro.numero_proceso,
            registro.radicado_tesoreria_numero,
            registro.radicado_tesoreria_fecha,
            registro.tipo_embargo,
            registro.demandante,
            registro.fecha_oficio,
            separateNumberByComma(registro.valor ?? '0'),
            separateNumberByComma(registro.valor_aplicado ?? '0'),
            separateNumberByComma(registro.total_levantamientos ?? '0'),
            separateNumberByComma(registro.valor_actual ?? '0'),
          ].map((valor) => ({ v: valor ?? '', t: 's', s: { alignment: { horizontal: 'center', vertical: 'middle' }, border: { top: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } } } } })));
        }

        const totales = this.totalesConsolidadoGobernacion;
        excel.push([
          'TOTALES', '', '', '', '', '', '', '', '', '',
          separateNumberByComma(totales.total_embargado ?? '0'),
          separateNumberByComma(totales.total_aplicado ?? '0'),
          separateNumberByComma(totales.total_levantado ?? '0'),
          separateNumberByComma(totales.total_saldo_actual ?? '0'),
        ].map((valor) => ({ v: valor ?? '', t: 's', s: { alignment: { horizontal: 'center', vertical: 'middle' }, font: { bold: true, size: 11 }, border: { top: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } } } } })));

        const ws = utils.aoa_to_sheet(excel);
        ws['!cols'] = Array(headers.length).fill({ wch: 28 });
        utils.book_append_sheet(wb, ws, 'CONSOLIDADO GOBERNACION');
        const fecha_doc = new Date(Date.now());
        writeFile(wb, `Consolidado_embargos_gobernacion_${fecha_doc.toLocaleDateString()}.xlsx`);
        return;
      }

      if (this.Tipo_embargo === 'consolidado') {
        const wb = utils.book_new();
        const headers = ['NÚMERO PROCESO', 'FECHA OFICIO', 'DEMANDADO', 'IDENTIFICACIÓN DEMANDADO', 'DEMANDANTE', 'IDENTIFICACIÓN DEMANDANTE', 'TIPO PROCESO', 'ESTADO REGISTRO', 'VALOR INICIAL', 'SALDO ACTUAL', 'TOTAL LIQUIDACIONES', 'TOTAL EGRESOS', 'TOTAL APLICADO', 'TOTAL REINTEGROS', 'TOTAL LEVANTAMIENTOS', 'PENDIENTE POR LEGALIZAR'];
        const excel = [headers.map((titulo) => ({ v: titulo, t: 's', s: { alignment: { horizontal: 'center', vertical: 'middle' }, font: { bold: true, size: 11, color: { rgb: '000000' } }, border: { top: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, left: { style: 'thin', color: { rgb: '000000' } } } } }))];

        for (const registro of this.collectionData) {
          excel.push([
            registro.numero_proceso,
            registro.fecha_oficio,
            registro.demandado,
            registro.identificacion_demandado,
            registro.demandante,
            registro.identificacion_demandante,
            registro.tipo_proceso,
            registro.estado_registro === 'borrador' ? 'Incompleto' : 'Finalizado',
            separateNumberByComma(registro.valor_inicial ?? '0'),
            separateNumberByComma(registro.valor_actual ?? '0'),
            separateNumberByComma(registro.total_liquidaciones ?? '0'),
            separateNumberByComma(registro.total_egresos ?? '0'),
            separateNumberByComma(registro.total_aplicado ?? '0'),
            separateNumberByComma(registro.total_reintegros ?? '0'),
            separateNumberByComma(registro.total_levantamientos ?? '0'),
            separateNumberByComma(registro.pendiente_por_legalizar ?? '0'),
          ].map((valor) => ({ v: valor ?? '', t: 's', s: { alignment: { horizontal: 'center', vertical: 'middle' }, border: { top: { style: 'thin', color: { rgb: '000000' } }, bottom: { style: 'thin', color: { rgb: '000000' } }, right: { style: 'thin', color: { rgb: '000000' } } } } })));
        }

        const ws = utils.aoa_to_sheet(excel);
        ws['!cols'] = Array(headers.length).fill({ wch: 30 });
        utils.book_append_sheet(wb, ws, 'CONSOLIDADO');
        const fecha_doc = new Date(Date.now());
        writeFile(wb, `Consolidado_embargos_personas_${fecha_doc.toLocaleDateString()}.xlsx`);
        return;
      }

      if (this.Tipo_embargo != 'cuentas') {
        await this.listCollectionData(
          (this.Tipo_embargo == 'persona') 
          ?
          process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDALL 
          :
          process.env.VUE_APP_NEST_EMBARGOGOBERNACION_FINDALL,
          
          {'collectionInforme': this.collectionInforme}, this.authToken,  this.page, this.queries['orderBy'], this.queries['order'], 
          this.queries['criterion'], this.queries['search'], this.queries['where'], true, { 'take' : 20000})
        .then(res => {
          if(this.Tipo_embargo == 'persona'){
              const report = [['Número Proceso', 'Tipo Proceso',  'Entidad Notificadora', 'Número Oficio', 'Fecha Oficio', 'Fecha Recibido OFicio', 'Identificación Demandante', 'Demandante', 'Tipo Persona Demandado', 'Identificación Demandado','Demandado', 'Limite Embargo', 'Saldo Actual']];
              
              this.dataFile = res.data;
            
              for (const data of this.dataFile) {
                const dataReport = {};
                for (const key in data) {
                  if(['numero_proceso', 'entidad_notifica_embargo',  'numero_oficio', 'fecha_oficio', 'fecha_recibido_oficio', 'valor_inicial', 'valor_actual'].includes(key)) {
                    dataReport[key] = data[key];
                  }
                  else if(key === 'tipoProceso') {
                    dataReport['tipoProceso'] = data[key]['nombre'];
                  }
                  else if(key === 'demandante') {
                    dataReport['demandante'] = (data[key]['primer_nombre'] || '') + ' ' + (data[key]['segundo_nombre'] || '') + ' ' + (data[key]['primer_apellido'] || '') + ' ' + (data[key]['segundo_apellido'] || '');
                    dataReport['identificacion_demandante'] = data[key]['identificacion'];
                  }
                  else if(key === 'demandado') {
                    dataReport['demandado'] = (data[key]['primer_nombre'] || '') + ' ' + (data[key]['segundo_nombre'] || '') + ' ' + (data[key]['primer_apellido'] || '') + ' ' + (data[key]['segundo_apellido'] || '');
                    dataReport['identificacion_demandado'] = data[key]['identificacion'];
                    dataReport['tipo_persona_demandado'] = data[key]['tipoPersona']['nombre'];
                  }
                }  
                const {
                  numero_proceso,
                  tipoProceso,
                  entidad_notifica_embargo,
                  numero_oficio,
                  fecha_oficio,
                  fecha_recibido_oficio,
                  identificacion_demandante,
                  demandante,
                  tipo_persona_demandado,
                  identificacion_demandado,
                  demandado,
                  valor_inicial,
                  valor_actual,
                } = dataReport
  
                report.push([
                numero_proceso,
                tipoProceso,
                entidad_notifica_embargo,
                numero_oficio,
                fecha_oficio,
                fecha_recibido_oficio,
                identificacion_demandante,
                demandante,
                tipo_persona_demandado,
                identificacion_demandado,
                demandado,
                Number(valor_inicial),
                Number(valor_actual),
              ]);
              }
          
              const workBook = utils.book_new();
              const workSheet = utils.aoa_to_sheet(report);
              utils.book_append_sheet(workBook, workSheet, 'Informe');  
  
              // Definir el ancho deseado para cada columna
              const columnWidths = [
                { wch: 18 }, // Ancho de la primera columna
                { wch: 18 }, // Ancho de la segunda columna
                { wch: 25 }, // Ancho de la segunda columna
                { wch: 18 },
                { wch: 18 },
                { wch: 22 },
                { wch: 24 },
                { wch: 24 },
                { wch: 24 },
                { wch: 24 },
                { wch: 23 },
                { wch: 20 },
                { wch: 20 },
  
              ];
  
              // Aplicar los anchos de columna a la hoja de trabajo
              workSheet['!cols'] = columnWidths;
  
              /** 
               * Genera un objeto de bordes para una celda.
               * @param {string} width - El ancho del borde. Puede ser "thin" o "medium".
               * @param {string} color - El color del borde en formato hexadecimal.
               * @returns {Object} - El objeto de bordes.
              */
              const generateBorder = (width, color) => {
                const borderObject = {};
                for (const side of ['left', 'right', 'bottom', 'top']) {
                  borderObject[side] = {
                    style: width,
                    color: {
                      rgb: color
                    }
                  };
                }
                return borderObject;
              };
  
              /**
              Agrega formato a las celdas del informe y genera el archivo xlsx.
              */
              for (const cell in workSheet) {
                if (cell.charAt(cell.length))
                  workSheet[cell]['s'] = {
                    font: {
                      bold: true,
                      color: {
                        rgb: 'FFFFFF'
                      },
                      sz: '10',
                      name: 'Open Sans'
                    },
                    border: generateBorder('medium', '000000'),
                    fill: {
                      bgColor: {
                        rgb: '000000'
                      }
                    }
                  };
                else if (typeof workSheet[cell] === 'object') workSheet[cell]['s'] = {
                  font: {
                    sz: '12',
                    name: 'Times New Roman'
                  },
                  border: generateBorder('thin', '000000')
                };
              }  
              writeFile(workBook, `informe_embargos_personas.xlsx`); 
  
          
          }else{
            const report = [['Juzgado - Entidad Cobro','Tipo Embargo', 'Número Oficio', 'Número Proceso', 'Número Embargo', 'Radicado', 'Número Egreso','Fecha Egreso','Identificación Demandante', 'Demandante', 'Observaciones', 'Banco', 'Cuenta Bancaria' , 'Tipo Cuenta', 'Fuente', 'Fuente Macro', 'Limite Embargo', 'Saldo']];
  
            this.dataFile = res.data;
  
            for (const data of this.dataFile) {
                const dataReport = {};
                for (const key in data) {
                  if(['numero_oficio', 'numero_embargo', 'radicado', 'numero_egreso', 'fecha_egreso', 'observaciones', 'numero_proceso', 'tipo_embargo','valor', 'valor_actual'].includes(key)) {
                    dataReport[key] = data[key];
                  }
                  else if(key === 'demandante') {
                    dataReport['demandante'] = (data[key]['primer_nombre'] || '') + ' ' + (data[key]['segundo_nombre'] || '') + ' ' + (data[key]['primer_apellido'] || '') + ' ' + (data[key]['segundo_apellido'] || '');
                    dataReport['identificacion_demandante'] = data[key]['identificacion'];
                  }
                  else if(key === 'cuentaBancaria') {
                    dataReport['nombre_banco'] = data[key]['banco']['nombre_banco'];
                    dataReport['cuentaBancaria'] = data[key]['cuenta_bancaria'];
                    dataReport['tipo_cuenta'] = data[key]['tipo_cuenta'];
                    dataReport['nombre_cuenta'] = data[key]['nombre_cuenta'];
                    dataReport['fuente_macro'] = data[key]['cuentasFuentesMacro']['macroFuente']['nombre'];
                  }
                  else if(key === 'juzgado' && data[key]) {
                    dataReport['juzgado_entidad_cobro'] = data[key]['nombre_juzgado'];
                  }
                  else if(key === 'entidadCobro' && data[key]) {
                    dataReport['juzgado_entidad_cobro'] = data[key]['nombre_entidad'];
                  }
                }  
  
                const {
                  juzgado_entidad_cobro,
                  tipo_embargo,
                  numero_oficio,
                  numero_proceso,
                  numero_embargo,
                  radicado,
                  numero_egreso,
                  fecha_egreso,
                  identificacion_demandante,
                  demandante,
                  observaciones,
                  nombre_banco,
                  cuentaBancaria,
                  tipo_cuenta,
                  nombre_cuenta,
                  fuente_macro,
                  valor,
                  valor_actual,
                } = dataReport
  
                report.push([
                juzgado_entidad_cobro,
                tipo_embargo,
                numero_oficio,
                numero_proceso,
                numero_embargo,
                radicado,
                numero_egreso,
                fecha_egreso,
                identificacion_demandante,
                demandante,
                observaciones,
                nombre_banco,
                cuentaBancaria,
                tipo_cuenta,
                nombre_cuenta,
                fuente_macro,
                Number(valor),
                Number(valor_actual),
              ]);
              }
          
              const workBook = utils.book_new();
              const workSheet = utils.aoa_to_sheet(report);
              utils.book_append_sheet(workBook, workSheet, 'Informe');  
  
  
              // Definir el ancho deseado para cada columna
              const columnWidths = [
                { wch: 18 }, // Ancho de la primera columna
                { wch: 18 }, // Ancho de la segunda columna
                { wch: 25 }, // Ancho de la segunda columna
                { wch: 18 },
                { wch: 25 },
                { wch: 22 },
                { wch: 24 },
                { wch: 24 },
                { wch: 24 },
                { wch: 24 },
                { wch: 23 }
              ];
  
              
              // Aplicar los anchos de columna a la hoja de trabajo
              workSheet['!cols'] = columnWidths;
  
  
              /** 
               * Genera un objeto de bordes para una celda.
               * @param {string} width - El ancho del borde. Puede ser "thin" o "medium".
               * @param {string} color - El color del borde en formato hexadecimal.
               * @returns {Object} - El objeto de bordes.
              */
              const generateBorder = (width, color) => {
                const borderObject = {};
                for (const side of ['left', 'right', 'bottom', 'top']) {
                  borderObject[side] = {
                    style: width,
                    color: {
                      rgb: color
                    }
                  };
                }
                return borderObject;
              };
  
              /**
              Agrega formato a las celdas del informe y genera el archivo xlsx.
              */
              for (const cell in workSheet) {
                if (cell.charAt(cell.length))
                  workSheet[cell]['s'] = {
                    font: {
                      bold: true,
                      color: {
                        rgb: 'FFFFFF'
                      },
                      sz: '10',
                      name: 'Open Sans'
                    },
                    border: generateBorder('medium', '000000'),
                    fill: {
                      bgColor: {
                        rgb: '000000'
                      }
                    }
                  };
                else if (typeof workSheet[cell] === 'object') workSheet[cell]['s'] = {
                  font: {
                    sz: '12',
                    name: 'Times New Roman'
                  },
                  border: generateBorder('thin', '000000')
                };
              }  
  
              writeFile(workBook, `informe_embargos_gobernacion.xlsx`); 
          }
        });
      }else{
        await this.listCollectionData(
          process.env.VUE_APP_NEST_CUENTASEMBARGOS_FINDALL,
          {'collectionInforme': this.collectionInforme}, this.authToken,  this.page, this.queries['orderBy'], this.queries['order'], 
          this.queries['criterion'], this.queries['search'], this.queries['where'], true, { 'take' : 20000})
        .then(res => {
          const wb = utils.book_new();
          let content = [];
          let headers = [
            [
              { v: "NOMBRE BANCO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "NOMBRE CUENTA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "NÚMERO CUENTA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "TIPO DE CUENTA", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "DETALLES EMBARGO GOBERNACION", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "DETALLES EMBARGO PERSONAS", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
              { v: "TOTAL PAGADO", t: "s", s: { alignment: { horizontal: "center", vertical: "middle" }, font: { bold: true, size: 11, color: { rgb: "000000" } }, border: { top: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, left: { style: "thin", color: { rgb: "000000" } } } } },
            ],
          ]
            res.forEach(element => {
              const detallesGobernacion = element.embargos.map(embargo => 
                `NÚMERO PROCESO: ${embargo.numero_proceso || ''}\n` +
                `NÚMERO EGRESO: ${embargo.numero_egreso || ''}\n` +
                `NÚMERO EMBARGO: ${embargo.numero_embargo || ''}\n` +
                `DINERO PAGADO: $${separateNumberByComma(parseInt(embargo.valor) - parseInt(embargo.valor_actual)) || ''}\n` +
                `______________${'__________________________'}`
              ).join('\n\n');
              
              const detalleExitosos= element.exitososEmbargosPersonas.map(personas => 
                `NÚMERO PROCESO: ${personas.embargos.numero_proceso || ''}\n` +
                `NÚMERO EGRESO: ${personas.embargos.numero_proceso || ''}\n` +
                `NÚMERO OFICIO: ${personas.embargos.numero_oficio || ''}\n` +
                `DINERO PAGADO: $${separateNumberByComma(personas.valor) || ''}\n` +
                `______________${'__________________________'}`
              ).join('\n\n');

              content = [ ...content,
                [
                  { v: element.banco.nombre_banco , t: "s", s: { alignment: { horizontal: "center", vertical: "center" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.nombre_cuenta , t: "s", s: { alignment: { horizontal: "center", vertical: "center" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.cuenta_bancaria, t: "s", s: { alignment: { horizontal: "center", vertical: "center" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: element.tipo_cuenta, t: "s", s: { alignment: { horizontal: "center", vertical: "center" }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: detallesGobernacion, t: "s", s: {alignment: { horizontal: "left", vertical: "top", wrapText: true }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } } },
                  { v: detalleExitosos, t: "s", s: { alignment: { horizontal: "left", vertical: "top", wrapText: true }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } }},
                  { v: `$${separateNumberByComma(element.totalEmbGobernacion + element.totalEmbPersonas)}` , t: "s", s: { alignment: { horizontal: "left", vertical: "top", wrapText: true }, border: { top: { style: "thin", color: { rgb: "000000" } }, bottom: { style: "thin", color: { rgb: "000000" } }, right: { style: "thin", color: { rgb: "000000" } } } }},
                ],
              ];
            });

          const excel = headers.concat(content)
          
          const ws = utils.aoa_to_sheet(excel);

          ws['!cols'] = Array(headers[0].length).fill({ wch: 40 });

          utils.book_append_sheet(wb, ws, 'CONSOLIDADO');
          const date = Date.now();
          const fecha_doc = new Date(date)
          writeFile(wb, `Consolidado_cuentas_bancarias_${fecha_doc.toLocaleDateString()}.xlsx`);
        });
      }
    },
  }
}

</script>


